import { redirect } from "react-router-dom"

export default function downloadRedirectLoader() {
  const storeUrl = /Android/.test(navigator.userAgent)
    ? (import.meta.env.VITE_APP_URL_GOOGLE_PLAY_STORE as string | undefined)
    : (import.meta.env.VITE_APP_URL_APPLE_APP_STORE as string | undefined)

  return redirect(storeUrl || "/")
}
